"use strict";

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DraggableModal = void 0;

var _react = _interopRequireWildcard(require("react")),
    _v = _interopRequireDefault(require("uuid/v4")),
    _DraggableModalContext = require("./DraggableModalContext"),
    _DraggableModalInner = require("./DraggableModalInner"),
    _draggableModalReducer = require("./draggableModalReducer");

require("./styles.css");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

function _slicedToArray(a, b) {
  return _arrayWithHoles(a) || _iterableToArrayLimit(a, b) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(a, b) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        d || null == h["return"] || h["return"]();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }
}

function _arrayWithHoles(a) {
  if (Array.isArray(a)) return a;
}

function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

var DraggableModal = function DraggableModal(a) {
  var b = a.initialZIndex,
      c = _objectWithoutProperties(a, ["initialZIndex"]),
      d = (0, _react.useState)((0, _v["default"])()),
      e = _slicedToArray(d, 1),
      f = e[0],
      g = (0, _react.useContext)(_DraggableModalContext.DraggableModalContext);

  if (!g) throw new Error("No Provider");
  b && (0, _draggableModalReducer.setInitialModalStateZIndex)(b);
  var h = g.dispatch,
      i = g.state,
      j = (0, _draggableModalReducer.getModalState)(i, f); // We do this so that we don't re-render all modals for every state change.
  // DraggableModalInner uses React.memo, so it only re-renders if
  // if props change (e.g. modalState).

  return _react["default"].createElement(_DraggableModalInner.DraggableModalInner, _extends({
    id: f,
    dispatch: h,
    modalState: j
  }, c));
};

exports.DraggableModal = DraggableModal;